export default "__VITE_ASSET__CDO_UvN7__"